const scrollMap = new Map();

export const saveSubCategoryScroll = (scid) => {
  if (!scid) return;
  const y =
    window.pageYOffset ||
    window.scrollY ||
    document.documentElement?.scrollTop ||
    document.body?.scrollTop ||
    0;
  if (y > 0) {
    scrollMap.set(String(scid), y);
    try {
      sessionStorage.setItem(`sc_scroll_${scid}`, String(y));
    } catch (e) {}
  }
};

export const getSubCategoryScroll = (scid) => {
  if (!scid) return 0;
  const inMem = scrollMap.get(String(scid));
  if (typeof inMem === "number" && inMem > 0) {
    return inMem;
  }
  try {
    const fromStorage = sessionStorage.getItem(`sc_scroll_${scid}`);
    if (fromStorage) {
      const parsed = parseInt(fromStorage, 10);
      if (!isNaN(parsed) && parsed > 0) {
        return parsed;
      }
    }
  } catch (e) {}
  return 0;
};

export const clearSubCategoryScroll = (scid) => {
  if (!scid) return;
  scrollMap.delete(String(scid));
  try {
    sessionStorage.removeItem(`sc_scroll_${scid}`);
  } catch (e) {}
};

